import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../../App.css';
import { findOrder, formatCurrency, LAUNCH_DATE } from '../../utils/orderStorage';
import { downloadOrderReceipt } from '../../utils/receiptGenerator';

const launchDateLabel = new Intl.DateTimeFormat('en-ZA', {
  dateStyle: 'long',
}).format(LAUNCH_DATE);

const statusOrder = ['Payment confirmed', 'Awaiting launch day', 'Packed for dispatch', 'In transit', 'Delivered'];

function TrackOrder() {
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState(searchParams.get('orderId') || '');
  const [searched, setSearched] = useState(false);
  const [order, setOrder] = useState(() => findOrder((searchParams.get('orderId') || '').trim()));
  const [receiptError, setReceiptError] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    setOrder(findOrder(orderId.trim()));
    setSearched(true);
  };

  const currentStep = order ? statusOrder.indexOf(order.liveStatus) : -1;

  return (
    <main className='content-page'>
      <section className='form-panel'>
        <h1>Track Your Mukwei Order</h1>
        <p className='section-copy'>
          Deliveries begin on {launchDateLabel}. Enter your order reference to view its latest status.
        </p>

        <form className='track-form' onSubmit={handleSubmit}>
          <label htmlFor='orderId'>Order reference</label>
          <input
            id='orderId'
            placeholder='Example: MUK-123456'
            value={orderId}
            onChange={(event) => setOrderId(event.target.value)}
            required
          />
          <button type='submit' className='cta-button primary full-width'>
            Track Order
          </button>
        </form>

        {order && (
          <div className='tracking-card'>
            <h2>{order.id}</h2>
            <p>Status: {order.liveStatus}</p>
            <p>Quantity: {order.quantity} bottle(s)</p>
            <p>Total paid: {formatCurrency(order.total)}</p>
            <p>Estimated delivery: {new Date(order.estimatedDelivery).toLocaleDateString('en-ZA')}</p>

            <div className='status-list'>
              {statusOrder.map((status, index) => (
                <div key={status} className={index <= currentStep ? 'status-item active' : 'status-item'}>
                  {status}
                </div>
              ))}
            </div>
            {order.deliveryToken && (
              <button
                type='button'
                className='cta-button primary full-width receipt-button'
                onClick={() => {
                  setReceiptError('');
                  downloadOrderReceipt(order).catch((error) => setReceiptError(error.message));
                }}
              >
                Download paid receipt <span aria-hidden='true'>↓</span>
              </button>
            )}
            {receiptError && <p className='receipt-error' role='alert'>{receiptError}</p>}
          </div>
        )}

        {!order && searched && (
          <div className='tracking-card'>
            <p>
              We could not find an order with that reference. Check the ID from your confirmation and
              try again.
            </p>
          </div>
        )}

        <div className='hero-actions'>
          <Link to='/checkout' className='cta-button secondary'>
            Create New Pre-order
          </Link>
        </div>
      </section>
    </main>
  );
}

export default TrackOrder;
